// All-pairs validation for the Current Loan Dashboard. The wizard validates and saves every
// borrower pair in Steps 1, 2, 4, 5 and 6, so the Dashboard does too: each section runs its
// per-pair validator over every pair, the badge is Completed only when every pair passes,
// and the save message names the first pair with a problem.

const REQUIRED_MESSAGE = "Please provide a value for all fields highlighted above.";

/**
 * @param {object[]} pairs Dashboard pair state
 * @param {(pair: object, index: number) => Set<string>} getErrors per-pair validator
 * @returns {{byPair: Set<string>[], firstInvalid: number, isValid: boolean}}
 */
export const getPairErrorMap = (pairs, getErrors) => {
	const byPair = (pairs || []).map((pair, index) => getErrors(pair, index));
	const firstInvalid = byPair.findIndex((errors) => errors.size > 0);
	return { byPair, firstInvalid, isValid: firstInvalid === -1 };
};

/** Save message for a failed all-pairs validation. */
export const pairErrorMessage = (firstInvalid, pairCount) =>
	pairCount > 1 && firstInvalid >= 0
		? `Pair ${firstInvalid + 1} is missing required fields. ${REQUIRED_MESSAGE}`
		: REQUIRED_MESSAGE;

/**
 * Keys flagged by the last blocked Save that are still invalid now — a field stops being
 * highlighted as soon as it is fixed, while untouched fields stay red.
 * @param {Set<string>|undefined} flagged keys captured when Save failed validation
 * @param {Set<string>|undefined} live keys the validator reports for the current values
 * @returns {Set<string>}
 */
export const intersectErrors = (flagged, live) => {
	const shown = new Set();
	if (!flagged || !live) return shown;
	flagged.forEach((key) => {
		if (live.has(key)) shown.add(key);
	});
	return shown;
};
